import { Tooltip, Text, StyleProps } from '@chakra-ui/react';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

export const TextWithCopy = (props: {
  children: Util.Maybe<string>;
  label?: string;
  styleProps?: StyleProps;
}) => {
  const { children: textInput, label, styleProps } = props;

  if (!textInput) {
    return null;
  }

  return (
    <Tooltip label={label || 'Copy to Clipboard'}>
      <Text
        as="span"
        onClick={() => {
          navigator.clipboard.writeText(textInput);
        }}
        _hover={{ cursor: 'grab' }}
        {...styleProps}
      >
        {textInput}
      </Text>
    </Tooltip>
  );
};
